import { Loader2, MoreVerticalIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { queryClient } from "@/lib/react-query";

import {
  MfaType,
  useDisableMfa,
  useUnPreferredMfa,
  useUpdatePreferredMfa,
} from "../api/update-preferred-mfa";

type MfaSettingsRowProps = {
  type: MfaType;
  isDefault: boolean;
  openModal: () => void;
};

export function MfaSettingsRow({
  type,
  isDefault,
  openModal,
}: MfaSettingsRowProps) {
  const { mutateAsync: updatePreferredMfa, isPending: isUpdatingPreferredMfa } =
    useUpdatePreferredMfa({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["mfa"] });
      },
    });
  const { mutateAsync: unPreferredMfa, isPending: isUnPreferredMfa } =
    useUnPreferredMfa({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["mfa"] });
      },
    });
  const { mutateAsync: disableMfa, isPending: isDisablingMfa } = useDisableMfa({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["mfa"] });
    },
  });

  const handleUpdatePreferredMfa = async () => {
    await updatePreferredMfa({ type });
  };

  const handleDisableMfa = async () => {
    await disableMfa({ type });
  };

  const handleUnPreferredMfa = async () => {
    await unPreferredMfa({ type });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <MoreVerticalIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {isDefault ? (
          <DropdownMenuItem onClick={handleUnPreferredMfa}>
            {isUnPreferredMfa ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              "Unset as default"
            )}
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem onClick={handleUpdatePreferredMfa}>
            {isUpdatingPreferredMfa ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              "Set as default"
            )}
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onClick={openModal}>Update</DropdownMenuItem>

        {!isDefault && (
          <DropdownMenuItem
            className="text-destructive"
            onClick={handleDisableMfa}
          >
            {isDisablingMfa ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              "Disable"
            )}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
